module.exports = __webpack_public_path__ + "img/img_status_done.4dc2f81b.svg";